// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'

import Vant from 'vant'
import 'vant/lib/index.css'

// import MintUI from 'mint-ui'
// import 'mint-ui/lib/style.css'
import '@/styles/index.scss'
import '@/styles/iconfont/iconfont.css'
import 'lib-flexible/flexible.js'
import store from './store'
import { getToken } from '@/utils/auth'
import { getCode } from '@/utils'
import { userauth } from '@/api/login'
import { initWxJssdkFilter } from '@/utils/common'
import preventReClick from '@/utils/dbClick'
Vue.use(preventReClick)

// import VueVideoPlayer from 'vue-video-player'
// import 'video.js/dist/video-js.css'
// import 'vue-video-player/src/custom-theme.css'
// import 'videojs-flash'
// import 'videojs-contrib-hls'
// Vue.use(VueVideoPlayer)

import App from './App.vue'
import { Toast } from 'vant';

Vue.use(Vant)

Vue.config.productionTip = false
const isDevelopment = process.env.NODE_ENV === 'development'
if (isDevelopment) {

    router.beforeEach((to, from, next) => {
        store.dispatch('Login').then(() => {
            // initWxJssdkFilter()
            if (to.name == 'indexPage') {
                store.dispatch('changeNav', '0')
            } else if (to.name == 'withdrawal') {
                store.dispatch('changeNav', '1')
            } else if (to.name == 'indexPage') {
                store.dispatch('myPage', '2')
            }
            if (to.meta.level == '1') {
                store.dispatch('showNav', true)
            } else {
                store.dispatch('showNav', false)
            }
        }).then(() => {
            next()
        })
    })
} else {
    // 鉴权（暂时隐藏）
    router.beforeEach(function(to, from, next) {
        console.log(to.meta, "meta---------");
        document.title = to.meta.title
            // Vue.$vux.loading.show({
            //   text: '加载中'
            // })   
        var hasLogin = getToken()
        if (hasLogin) {
            next()
        } else {
            var path = to.path
            var hash = location.hash //获取锚点值
                // let alarmid = getCode('alarmid')
            let pageUrl = window.location.href

            var url = encodeURIComponent(pageUrl)
            console.log(pageUrl, '------------', hash)

            var appid = process.env.APPID;
            var urlWX = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + url + "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect"

            var hasCode = getCode('code')

            console.log(hasCode, '是否')
            if (hasCode) {
                store.dispatch('Login').then(() => {
                    if (to.name == 'indexPage') {
                        store.dispatch('changeNav', '0')
                    } else if (to.name == 'withdrawal') {
                        store.dispatch('changeNav', '1')
                    } else if (to.name == 'indexPage') {
                        store.dispatch('myPage', '2')
                    }
                    if (to.meta.level == '1') {
                        store.dispatch('showNav', true)
                    } else {
                        store.dispatch('showNav', false)
                    }

                    next()
                }).then(() => {
                    // if(store.getters.isbind == '0'){
                    //   router.push({
                    //     path: '/bindLogin'
                    //   })
                    // }
                    console.log('执行成功2')
                    router.push({
                        path: '/'
                    })
                })
            } else {
                window.location.href = urlWX
            }

        }

    })
}




router.afterEach(function(to, from) {
    // var _this = this

    setTimeout(function() {
        Toast.clear();
    }, 200)
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js